import { isoDate } from 'utils/LocalDateTimeHelper';

// Check the incoming URL against each rule, until a pattern is matched, then run that rule's function to get the destination
export function matchUrlForRedirect (originalUrl) {
  rulesList = rulesList || parsedRules(); // only call it once

  let found = false;
  rulesList.forEach(rule => {
    if (!found) {
      const match = originalUrl.match(rule.pattern);

      if (match) {
        found = rule.redirect(match); // quick break
      }
    }
  })
  return found;
}

// Rules are specified as an object, so keep the list simple. This function "compiles" that into an array of Regexes and associated functions
function parsedRules() {
  return Object.keys(urlRewriteRules).map(o => {
    const rule = {
      pattern: new RegExp(`^${o}`),
      redirect: urlRewriteRules[o]
    };

    if ((typeof urlRewriteRules[o]) == "string") { // allow specifying a string for the simple cases (most of them are simple)
      rule.redirect = () => urlRewriteRules[o];
    }

    return rule;
  });
}

///////////////////////////////////////////
// Some helpers for common rule patterns
// Particularly useful for non-trivial rules

function dateExtracter(prefix) {
  const splitStart = prefix.length + 1;

  return function (input) {
    const [dateText] = input.substring(splitStart).split("/");
    return Date.parse(dateText);
  }
}

export function titleToId(title){
return title.replace(/\s+/g, '-').toLowerCase();

}

function tooLittlePath(prefix, {preserveDate = false} = {}) {
  const tooLittlePathRegex = `${prefix}/[0-9-]+/[^/]+$`;
  const extractDate = dateExtracter(prefix);

  return {
    [tooLittlePathRegex]: ({input}) => {
      let redirect = prefix;

      if (preserveDate) {
        const dateNumber = extractDate(input);

        if (dateNumber) {
          redirect = `${redirect}/${isoDate(dateNumber)}`;
        }
      }

      return redirect;
    }
  };
}


// Catch incorrect date formats and attempt to correct them
function badDateFormat(prefix, {allowTomorrow = false, allowYesterday = false, allowCompetitionTeams = false} = {}) {
  const badDateRegex = `${prefix}/[0-9](?!([0-9]{3}-[0-9]{2}-[0-9]{2}))`;
  const extractDate = dateExtracter(prefix);

  let allowText = "";

  if (allowTomorrow || allowYesterday || allowCompetitionTeams) {
    const allowed = [];

    if (allowTomorrow) {
      allowed.push("tomorrow");
    }

    if (allowYesterday) {
      allowed.push("yesterday");
    }

    if (allowCompetitionTeams) {
      allowed.push("competitions");
      allowed.push("teams");
    }

    allowText = `(?!${allowed.join("|")})`;
  }

  const badTextRegex = `${prefix}/${allowText}[^0-9]+`;

  return {
    [badDateRegex] : ({input}) => {
      let redirect = prefix;
      const dateNumber = extractDate(input);

      if (dateNumber) {
        redirect = `${redirect}/${isoDate(dateNumber)}`;
      }

      return redirect;
    },
    [`${prefix}/Today`]: prefix, // Old site appears to have used capital "T"
    [badTextRegex]: ({input}) => `/error/404${input}`
  };
}

// Catch old format news articles, without breaking new ones
function legacyNews(section) {
  return {
    [`${section}(?!/news)/(.*)`]: section,
    ...newsIndex(section)
  };
}

function newsIndex(section) {
  return {
    [`${section}/news/article/[0-9]+/[0-9]+/.*`]: section,
    ...exact(`${section}/news`, section)
  };
}

function prefixed(path, redirect) {
  return {
    [`${path}/(.*)`]: redirect,
    ...exact(path, redirect)
  };
}

function exact(path, redirect) {
  return {
    [`${path}$`]: redirect
  };
}

let rulesList; // ready to cache the "compiled" rule list

// and finally, the rules
const urlRewriteRules = {
  ...prefixed('/bettingzone/cricket', '/cricket'),
  ...exact('/about-us', '/'),
  ...exact('/ascot', '/racing'),
  ...exact('/betting-blog', '/'),
  ...exact('/bettingzone', '/'),
  ...prefixed('/bettingzone/67', '/'),
  ...prefixed('/bettingzone/american-football', '/nfl'),
  ...exact('/bettingzone/calculator', '/'),
  ...exact('/bettingzone/cheeky-punt', '/'),
  ...exact('/bettingzone/converter', '/'),
  ...prefixed('/bettingzone/football', '/football'),
  ...prefixed('/bettingzone/golf', '/golf'),
  ...exact('/bettingzone/market_moves', '/'),
  ...exact('/bettingzone/market-movers', '/'),
  ...exact('/bettingzone/market-moves', '/'),
  ...exact('/bettingzone/news', '/'),
  ...prefixed('/bettingzone/news/racing', '/racing'),
  ...prefixed('/bettingzone/other-sports', '/'),
  ...exact('/bettingzone/our-best-bets', '/'),
  ...prefixed('/bettingzone/previews', '/'),
  ...prefixed('/bettingzone/racing', '/racing'),
  ...exact('/bettingzone/record', '/'),
  ...prefixed('/bettingzone/rugby-league', '/rugby-league'),
  ...prefixed('/bettingzone/tennis', '/tennis'),
  ...prefixed('/bettingzone/tipsters', '/columnists'),
  ...prefixed('/bettingzone', '/'),
  ...legacyNews('/boxing'),
  ...exact('/calendar', '/'),
  ...exact('/calendar/sportsday.html', '/'),
  ...prefixed('/clients/ft/racing/news', '/racing'),
  ...prefixed('/clients/planetf1', '/formula1'),
  ...prefixed('/clients/stanjames/football', '/football'),
  ...prefixed('/clients/tiscali/football/transfer_centre', '/football'),
  ...exact('/columns/quiz', '/'),
  ...exact('/columns/tv', '/'),
  ...prefixed('/commonwealth2006', '/'),
  ...prefixed('/comp', '/'),
  ...exact('/competitions', '/'),
  ...exact('/contact-us', '/'),
  ...exact('/other-sports/news/article/678/10108332/key-sports-dates-for-2016-sporting-events-calendar', '/'),
  ...legacyNews('/cricket'),
  ...exact('/darts/news/article/10310/10541021/premier-league-darts-2017-fixtures-results-table-dates-venues-tv-schedule-odds', '/football/results/competitions/english-premier-league/1'),
  ...legacyNews('/darts'),
  ...exact('/football/champions-league/table', '/football/results/competitions/champions-league/63'),
  ...exact('/football/news/article/226/10693286/details-of-the-champions-league-last-16-draw-arsenal-leicester-manchester-city', '/football/fixtures/competitions/champions-league/63'),
  ...exact('/football/news/article/165/10775746/tuesday-champions-league-betting-preview-and-tips', '/football/results/competitions/champions-league/63'),
  ...exact('/football/news/article/165/10551310/champions-league-draw-live', '/football/fixtures/competitions/champions-league/63'),
  ...exact('/football/news/article/165/10723563/fa-cup-fourth-round-draw', '/football/fixtures/competitions/english-fa-cup/76'),
  ...exact('/football/news/article/165/10684753/fa-cup-3rd-round-draw-holders-man-utd-to-host-reading-west-ham-v-man-city', '/football/fixtures/competitions/english-fa-cup/76'),
  ...exact('/football/news/article/165/10770833/fa-cup-team-statistics-betting-tips-predictions-and-kick-off-times', '/football/fixtures/competitions/english-fa-cup/76'),
  ...exact('/football/news/article/165/10738026/scottish-cup-fourth-round-review-and-results-saturday-january-21', '/football/results/competitions/scottish-fa-cup/71'),
  ...exact('/football/news/article/165/10724477/manchester-united-v-liverpool-team-news-predictions-statistics-odds-kick-off-time', '/football/fixtures/competitions/english-premier-league/1'),
  ...exact('/football/news/article/165/10697280/everton-v-liverpool-team-news-predictions-statistics-odds-kick-off-time', '/football/fixtures/competitions/english-premier-league/1'),
  ...exact('/football/news/article/165/10316446/scottish-premiership-fixtures-announced-rangers-to-visit-celtic-on-september-10', '/football/fixtures/competitions/scottish-premiership/62'),
  ...exact('/football/news/article/165/10741597/chelsea-v-arsenal-team-news-predictions-statistics-odds-kick-off-time', '/football/fixtures/competitions/english-premier-league/1'),
  ...exact('/football/news/article/165/9924995/world-cup-2018-qualifying-draw-groups-fixtures-schedule', '/football/fixtures/competitions/world-cup/18'),
  ...exact('/football/news/article/165/10727546/africa-cup-of-nations-2017-fixtures-schedule-groups-results-odds-tv-guide', '/football/fixtures/competitions/african-world-cup-qualifiers/22'),
  ...exact('/football/news/article/165/10614599/africa-cup-of-nations-2017-which-premier-league-players-are-off-to-gabon', '/football/fixtures/competitions/african-world-cup-qualifiers/22'),
  ...exact('/football/news/article/165/10704629/manchester-united-v-sunderland-team-news-predictions-statistics-odds-kick-off-time', '/football/fixtures'),
  ...exact('/football/news/article/165/10667289/liverpool-v-sunderland-team-news-statistics-predictions-odds-kick-off-time', '/football/fixtures'),
  ...exact('/football/news/article/165/10759538/arsenal-v-hull-team-news-predictions-statistics-odds-kick-off-time', '/football/fixtures'),
  ...exact('/football/news/article/165/9946849/premier-league-betting-tips-preview-of-aston-villa-v-man-utd', '/football/fixtures'),
  ...exact('/football/news/article/678/10735798/live-football-on-tv-today-plus-horse-racing-tennis-cricket-darts-golf', '/football/fixtures'),
  ...exact('/football/news/article/165/10685681/manchester-united-v-tottenham-team-news-predictions-statistics-odds-kick-off-time', '/football/fixtures/competitions/english-premier-league/1'),
  ...exact('/football/news/article/165/10678208/manchester-city-v-chelsea-team-news-statistics-predictions-odds-kick-off-time', '/football/fixtures/competitions/english-premier-league/1'),
  ...exact('/football/news/article/165/10770858/newcastle-united-v-aston-villa-football-betting-tips-team-news-manager-quotes-kick-off-time', '/football/results/competitions/sky-bet-championship/10'),
  ...exact('/football/news/article/165/10658399/tottenham-hotspur-v-west-ham-united-team-news-statistics-predictions-odds-kick-off-time-tv-channel', '/football/fixtures/competitions/english-premier-league/1'),
  ...exact('/football/news/article/165/10690767/everton-v-arsenal-team-news-predictions-statistics-odds-kick-off-time', '/football/fixtures/competitions/english-premier-league/1'),
  ...exact('/football/news/article/165/9913283/sky-sports-fantasy-football-is-back-for-the-new-barclays-premier-league-season', '/football/tips-centre'),
  ...exact('/football/news/article/3538/10630948/philippe-coutinho-eden-hazard-sadio-mane-in-sky-sports-fantasy-football-team-of-the-week', '/football/tips-centre'),
  ...exact('/football/news/article/165/10523475/efl-football-betting-tips-for-championship-league-one-and-league-two', '/football/tips-centre'),
  ...exact('/football/news/article/165/10188718/soccer-saturday-super-6-matches-on-saturday', '/football/tips-centre'),
  ...exact('/football/news/article/165/10588593/super-6-predictions-for-the-soccer-saturday-super-6-game', '/football/tips-centre'),
  ...exact('/football/video/24811/10626357/mersons-super-six-predictions', '/football/tips-centre'),
  ...exact('/football/news/article/165/10692375/premier-league-football-results-and-review-for-sunday-december-11', '/football/results/competitions/english-premier-league/1'),
  ...exact('/football/news/article/165/10704880/tottenham-v-chelsea-team-news-predictions-statistics-odds-kick-off-time', '/football/fixtures/competitions/english-premier-league/1'),
  ...exact('/football/europa-league/table', '/football/fixtures/competitions/uefa-europa-league/70'),
  ...exact('/football/fa-cup/results', '/football/results/competitions/english-fa-cup/76'),
  ...exact('/football/fa-cup', '/football/fixtures/competitions/english-fa-cup/76'),
  ...exact('/football/fa-cup/draw', '/football/fixtures/competitions/english-fa-cup/76'),
  ...exact('/snooker/news/article/663/10241983/world-championship-snooker-2016-draw-schedule-results', '/snooker/news/world-championship-snooker-draw/146449'),
  ...exact('/football/scottish-league-cup/draw', '/football/fixtures/competitions/english-league-cup/50'),
  ...exact('/football/efl-cup/draw', '/football/fixtures/competitions/english-league-cup/50'),
  ...exact('/football/video/24811/10740437/rodgers-enjoyable-scottish-cup-draw', '/football/fixtures/competitions/scottish-fa-cup/71'),
  ...exact('/football/scottish-league-cup/results', '/football/results/competitions/scottish-fa-cup/71'),
  ...exact('/football/live/match-preview/357153/celtic-v-aberdeen', '/football/results/competitions/scottish-premiership/62'),
  ...exact('/football/scottish-football', '/football/league-tables/scottish-premiership/62'),
  '/football/scottish-football/(.*)': '/football',
  ...exact('/football/scottish-premier/table', '/football/league-tables/scottish-premiership/62'),
  ...exact('/football/scottish-premier/fixtures', '/football/results/competitions/scottish-premiership/62'),
  ...exact('/football/premier-league/top-scorers', '/football/league-tables/english-premier-league/1'),
  ...exact('/football/premier-league/swansea-city/fixtures', '/football/fixtures/teams/swansea-city/2/english-premier-league/1'),
  ...exact('/football/premier-league/results', '/football/results/competitions/english-premier-league/1'),
  ...exact('/football/premier-league', '/football/league-tables/english-premier-league/1'),
  ...exact('/football/premier-league/hull-city/fixtures', '/football/fixtures/competitions/sky-bet-championship/10'),
  ...exact('/football/premier-league/teams', '/football'),
  '/football/premier-league/(.*)': '/football',
  ...exact('/football/teams/leicester-city/fixtures', '/football/fixtures/teams/leicester-city/8/english-premier-league/1'),
  ...exact('/football/teams/tottenham-hotspur', '/football/results/competitions/english-premier-league/1'),
  ...exact('/football/teams/manchester-city', '/football/results/competitions/english-premier-league/1'),
  ...exact('/football/teams/tottenham-hotspur', '/football/results/competitions/english-premier-league/1'),
  ...exact('/football/europa-league/fixtures', '/football/fixtures/competitions/uefa-europa-league/70'),
  ...exact('/football/europa-league/results', '/football/results/competitions/uefa-europa-league/70'),
  ...exact('/football/live/match-commentary/362915/malaga-v-las-palmas', '/football/fixtures/teams/las-palmas/1082/spanish-la-liga/74'),
  ...exact('/football/la-liga/results', '/football/results/competitions/spanish-la-liga/74'),
  ...exact('/football/la-liga(.*)', '/football/league-tables/spanish-la-liga/74'),
  ...exact('/football/la-liga', '/football/league-tables/spanish-la-liga/74'),
  ...exact('/football/teams/cardiff-city/fixtures', '/football/fixtures/competitions/sky-bet-championship/10'),
  ...exact('/football/live/latest-scores', '/football/results/competitions/sky-bet-championship/10'),
  ...exact('/football/live/league-tables/league-two', '/football/league-tables/sky-bet-league-two/83'),
  ...exact('/football/league-two', '/football/league-tables/sky-bet-league-two/83'),
  ...exact('/football/league-two/results', '/football/results/competitions/sky-bet-league-two/83'),
  '/football/league-two/(.*)': '/football',
  ...exact('/football/league-one/results', '/football/results/competitions/sky-bet-league-one/16'),
  ...exact('/football/league-one', '/football/fixtures/competitions/sky-bet-league-one/16'),
  ...exact('/football/league-one/(.*)', '/football/results/competitions/sky-bet-league-one/16'),
  ...exact('/football/teams/wigan-athletic/fixtures', '/football/fixtures/teams/wigan-athletic/38/sky-bet-league-one/16'),
  ...exact('/football/bundesliga', '/football/league-tables/german-bundesliga/11'),
  ...exact('/football/bundesliga/results', '/football/results/competitions/german-bundesliga/11'),
  ...exact('/football/bundesliga/fixtures', '/football/fixtures/competitions/german-bundesliga/11'),
  '/football/bundesliga/(.*)': '/football',
  ...exact('/football/teams/sunderland', '/football/results'),
  ...exact('/football/news/article/26854/10320946/football-fixture-list-for-premi_1', '/football/fixtures'),
  ...exact('/football/live/team-lineups', '/football/fixtures'),
  ...newsIndex('/football'), //catch-all for /football/news/article anything absolute news specific URIs before this!
  ...prefixed('/football/cc_championship', '/football'),
  ...prefixed('/football/cc_league1', '/football'),
  ...prefixed('/football/cc_league2', '/football'),
  ...prefixed('/football/champ_draw', '/football'),
  ...exact('/football/championship/sheffield-wednesday/fixtures', '/football/fixtures/teams/sheffield-wednesday/221/sky-bet-championship/10'),
  ...exact('/football/championship/top-scorers', '/football/league-tables/sky-bet-championship/10'),
  ...exact('/football/championship(.*)', '/football/fixtures/competitions/sky-bet-championship/10'),
  ...prefixed('/football/champions-league', '/football'),
  ...prefixed('/football/cups', '/football'),
  ...prefixed('/football/efl-cup', '/football'),
  ...prefixed('/football/eredivisie', '/football'),
  ...prefixed('/football/euro2004', '/football'),
  ...prefixed('/football/euro2012', '/football'),
  ...prefixed('/football/euro-2016', '/football/results/competitions/european-world-cup-qualifiers/9'),
  ...prefixed('/football/europa-league', '/football'),
  ...prefixed('/football/europa-league-qualifying', '/football'),
  ...prefixed('/video/23481/10755550/chelsea-v-arsenal-volley-challenge', '/football'),
  ...exact('/snooker/news/article/663/10638569/mark-selby-thrashes-ding-junhui-to-win-international-championship', '/snooker/news/ding-destroys-xiao-to-reach-last-16/146782'),
  ...exact('/racing/news/article/465/10743050/doncaster-takes-precautions-against-frost-fears', '/racing/meeting/2018-04-27/doncaster/65010'),
  ...exact('/racing/courses/doncaster', '/racing/meeting/2018-04-27/doncaster/65010'),
  ...exact('/racing/courses/chepstow', '/racing/meeting/2018-04-27/chepstow/65011'),
  ...exact('/racing/news/article/465/9712940/timeform', '/racing/tips-centre'),
  ...exact('/racing/meeting/goodwood/29-07-2016', '/racing/racecards'),
  ...exact('/racing/courses/aintree', '/racing/racecards'),
  ...exact('/racing/meeting/aintree/07-04-2016', '/racing/racecards'),
  ...exact('/racing/news/article/465/10512752/glorious-goodwood-full-recap', '/racing/results'),
  ...exact('/racing/news/article/465/10300765/epsom-derby-2016-betting-tips-odds-start-time-racecards-results', '/racing/racecards'),
  ...exact('/racing/courses/cartmel', '/racing/racecards'),
  ...exact('/racing/courses/beverley', '/racing/racecards'),
  ...exact('/racing/courses/goodwood', '/racing/racecards'),
  ...exact('/racing/courses/windsor', '/racing/racecards'),
  ...exact('/racing/meeting/haydock-park/02-07-2016', '/racing/racecards'),
  ...exact('/racing/courses/newmarket', '/racing/racecards'),
  ...exact('/racing/results/09-04-2016/wolverhampton/result/717616/like-wolverhampton-racecourse-on-facebook-handicap', '/racing/racecards'),
  ...exact('/racing/results/26-11-2016/newbury', '/racing/racecards'),
  ...exact('/racing/meeting/newbury/12-02-2011', '/racing/racecards'),
  ...exact('/racing/news/article/465/10735160/ascot-call-inspection-ahead-of-clarence-house-chase-fixture', '/racing/racecards'),
  ...exact('/racing/news/article/465/10243338/newbury-saturday-fixture-in-doubt-as-friday-card-abandoned', '/racing/racecards'),
  ...exact('/racing/results/06-07-2016/yarmouth/result/731709/great-yarmouth-mercury-handicap/video', '/racing/results'),
  ...exact('/racing/report/761621/disko-beats-flogas-rivals', '/racing/results'),
  ...exact('/racing/results/04-09-2016/philadelphia-park/result/742848/claiming', '/racing/results'),
  ...exact('/racing/racecards/01-01-2017/cheltenham/racecard/757505/betbright-casino-handicap-hurdle', '/racing/tips-centre'),
  ...exact('/racing/racecards/29-10-2016/wetherby/racecard/750422/olbg-com-mares-hurdle-listed', '/racing/tips-centre'),
  ...exact('/racing/news/article/465/10576301/ante-post-preview-for-the-william-hill-ayr-gold-cup', '/racing/tips-centre'),
  ...exact('/racing/racecards/05-11-2016/doncaster/racecard/751423/betfred-mobile-wentworth-stakes-listed', '/racing/tips-centre'),
  ...exact('/racing/news/article/465/10080027/cheltenham-festival-2017-schedule-racecards-betting-tips-odds-results-key-trials-form', '/racing/tips-centre'),
  ...exact('/racing/news/article/465/10220524/grand-national-2016-full-list-of-40-horses-odds-betting-tips-aintree-racecards-dates-times', '/racing/tips-centre'),
  ...exact('/racing/results/05-01-2016/southwell/result/707546/coral-mobile-just-three-clicks-to-bet-handicap', '/racing/tips-centre'),
  ...exact('/racing/profiles/horse/945637/bo-selecta', '/racing/profiles/horse/18525'),
  ...exact('/racing/profiles/horse/727538/embankment', '/racing/profiles/horse/256855'),
  ...exact('/racing/profiles/horse/739877/waldorf-salad', '/racing/profiles/horse/263296'),
  ...exact('/racing/profiles/horse/792740/modus', '/racing/profiles/horse/473'),
  ...exact('/racing/profiles/horse/852806/identity-thief', '/racing/profiles/horse/9618'),
  ...exact('/racing/profiles/horse/595764/jessie-jane-ire', '/racing/profiles/horse/210351'),
  ...exact('/racing/report/386354/cosmos-out-of-this-world-in-leger', '/racing/profiles/horse/373713'),
  ...exact('/racing/profiles/horse/2464/eliza-dolittle', '/racing/profiles/horse/77714'),
  ...exact('/racing/profiles/horse/61314/blue-tomato', '/racing/profiles/horse/27159'),
  ...exact('/racing/profiles/horse/858163/duke-street', '/racing/profiles/horse/340377'),
  ...exact('/racing/profiles/horse/879457/papa-luigi', '/racing/profiles/horse/359659'),
  ...exact('/racing/profiles/horse/648539/commentary', '/racing/profiles/horse/880230'),
  ...exact('/racing/results/17-03-2016/cheltenham/result/708886/pertemps-network-final-listed-handicap-hurdle', '/racing/profiles/horse/51906'),
  ...exact('/racing/profiles/horse/905484/just-fab', '/racing/profiles/horse/24119'),
  ...exact('/racing/profiles/horse/947968/bravissimo', '/racing/profiles/horse/9668'),
  ...exact('/racing/profiles/horse/756628/goldie-horn', '/racing/profiles/horse/272768'),
  ...exact('/racing/profiles/horse/896711/koora', '/racing/profiles/horse/376889'),
  ...exact('/racing/profiles/horse/629721/dancing-leopard', '/racing/profiles/horse/259145'),
  ...exact('/racing/profiles/horse/846417/sykes', '/racing/profiles/horse/10944'),
  ...exact('/racing/profiles/horse/744852/baby-jake', '/racing/profiles/horse/265858'),
  ...exact('/racing/profiles/horse/279838/sexy-lady', '/racing/profiles/horse/319421'),
  ...exact('/racing/profiles/horse/895788/lumiere', '/racing/profiles/horse/375965'),
  ...exact('/racing/profiles/horse/319766/slugger-otoole', '/racing/profiles/horse/53561'),
  ...exact('/racing/profiles/horse/399383/gentlemen', '/racing/profiles/horse/799'),
  ...exact('/racing/profiles/trainer/306/k-c-bailey', '/racing/profiles/trainer/129'),
  ...exact('/racing/profiles/trainer/4254/d-pipe', '/racing/profiles/trainer/169'),
  ...exact('/racing/profiles/horse/859035/wait-for-me', '/racing/profiles/horse/10904'),
  ...exact('/racing/profiles/horse/759175/vicente', '/racing/profiles/horse/10972'),
  ...exact('/racing/profiles/horse/914661/atomix', '/racing/profiles/horse/14960'),
  ...exact('/racing/profiles/horse/621963/go-indigo', '/racing/profiles/horse/205515'),
  ...exact('/racing/profiles/horse/709175/vicky-valentine', '/racing/profiles/horse/247748'),
  ...exact('/racing/profiles/horse/829096/rocky-rider', '/racing/profiles/horse/320481'),
  ...exact('/racing/profiles/horse/877711/a-boy-named-sue', '/racing/profiles/horse/357931'),
  ...exact('/racing/profiles/horse/231280/mister-apples-fr', '/racing/profiles/horse/36724'),
  ...exact('/racing/profiles/horse/907083/remarkable', '/racing/profiles/horse/387252'),
  ...exact('/racing/profiles/horse/843643/who-dares-wins', '/racing/profiles/horse/468'),
  ...exact('/racing/profiles/trainer/14461/miss-s-smith', '/racing/profiles/trainer/121'),
  ...exact('/racing/profiles/trainer/67965/i-jardine', '/racing/profiles/trainer/346'),
  ...exact('/racing/profiles/trainer/4193/w-p-mullins/future-entries', '/racing/profiles/trainer/414'),
  ...exact('/racing/profiles/trainer/36948/i-mohammed', '/racing/profiles/trainer/178'),
  ...exact('/racing/profiles/jockey/23721/a-kirby', '/racing/profiles/jockey/793'),
  ...exact('/racing/profiles/jockey/72764/s-de-sousa', '/racing/profiles/jockey/3516'),
  ...exact('/racing/profiles/jockey/98041/d-r-fox', '/racing/profiles/jockey/754'),
  ...exact('/racing/profiles/jockey/620/hayley-turner', '/racing/profiles/jockey/2536'),
  ...exact('/racing/profiles/horse/338216/virtual_2', '/racing/abc-guide'),
  ...exact('/racing/news/article/465/10776342/paul-nicholls-stable-tour-including-zarkandar-and-movewiththetimes', '/racing/profiles/trainer/115'),
  ...exact('/racing/profiles/trainer/15101/a-m-balding', '/racing/profiles/trainer/3209'),
  ...exact('/football/transfer-centre/paper-talk', '/football/paper-talk'),
  ...badDateFormat('/football/results', {allowCompetitionTeams: true}),
  ...badDateFormat('/football/fixtures', {allowCompetitionTeams: true}),
  ...badDateFormat('/football/fixtures-results'),
  ...prefixed('/football/footballconference', '/football'),
  ...prefixed('/football/international', '/football/results/competitions/internationals/65'),
  ...prefixed('/football/la-liga', '/football'),
  ...prefixed('/football/league-cup', '/football'),
  ...prefixed('/football/ligue-1', '/football'),
  ...exact('/football/live/league-tables/championship', '/football/live'),
  ...exact('/football/live/latest_scores', '/football/live'),
  ...exact('/football/live/latest-commentary', '/football/live'),
  ...exact('/football/live/latestscores', '/football/live'),
  ...exact('/football/live/league-tables', '/football'),
  ...prefixed('/football/live/league-tables', '/football'),
  ...prefixed('/football/live/match', '/football'),
  ...prefixed('/football/live/match-betting', '/football/tips-centre'),
  ...prefixed('/football/live/match-commentary', '/football/live'),
  ...prefixed('/football/live/match-photos', '/football/live'),
  ...prefixed('/football/live/match-preview', '/football/live'),
  ...exact('/football/live/match-reaction', '/football/live'),
  ...prefixed('/football/live/match-reaction', '/football/live'),
  ...prefixed('/football/live/match-report', '/football/live'),
  ...exact('/football/live/match-reports', '/football/live'),
  ...prefixed('/football/live/match-stats', '/football/live'),
  ...exact('/football/live/reports', '/football/live'),
  ...prefixed('/football/live/tables', '/football/live'),
  ...prefixed('/football/live_match', '/football/live'),
  ...prefixed('/football/overseas', '/football'),
  ...prefixed('/football/photos', '/football'),
  ...prefixed('/football/player-profile', '/football'),
  ...prefixed('/football/popup', '/football'),
  ...prefixed('/football/premiership', '/football'),
  ...prefixed('/football/premteams', '/football'),
  ...exact('/football/scoreboard/index.html', '/football/results'),
  ...prefixed('/football/scotspremteams', '/football'),
  ...prefixed('/football/scottish1', '/football'),
  ...prefixed('/football/scottish-championship', '/football'),
  ...prefixed('/football/scottish-cup', '/football'),
  ...prefixed('/football/scottish-league-one', '/football'),
  ...prefixed('/football/scottish-premier', '/football'),
  ...prefixed('/football/scottishpremier', '/football'),
  ...exact('/football/serie-a', '/football/league-tables/italian-serie-a/6'),
  ...exact('/football/serie-a/(.*)', '/football'),
  ...prefixed('/football/suspensions', '/football'),
  ...prefixed('/football/tables', '/football'),
  ...prefixed('/football/team', '/football'),
  ...prefixed('/football/teams', '/football'),
  ...prefixed('/football/transfer_centre', '/football'),
  ...prefixed('/football/transfer-centre', '/football'),
  ...exact('/football/transfer-centre', '/football'),
  ...exact('/football/video', '/football'),
  '/football/video(.*)': '/football',
  ...prefixed('/football/world-cup', '/football'),
  ...prefixed('/football/worldcupfinals2002', '/football'),
  ...legacyNews('/formula1'),
  ...legacyNews('/golf'),
  ...newsIndex('/greyhounds'),
  ...tooLittlePath('/greyhounds/racecards'),
  ...badDateFormat('/greyhounds/racecards'),
  ...badDateFormat('/greyhounds/results', {allowYesterday: true}),
  ...exact('/greyhounds/abc-guide', '/greyhounds'),
  ...exact('/greyhounds/live-shows', '/greyhounds/racecards'),
  ...prefixed('/greyhounds/preview', '/greyhounds/racecards'),
  '/greyhounds/selections(.*)': '/greyhounds',
  ...legacyNews('/nfl'),
  ...exact('/pick7', 'https://pick7.sportinglife.com?dcmp=sl_redirect'),
  ...legacyNews('/other-sports'),
  ...newsIndex('/racing'),
  ...prefixed('/racing/ascot', '/racing'),
  ...exact('/racing/racecards/01-01-2015/southwell/racecard/655312/ladbrokes-mobile-handicap', '/racing/tips-centre'),
  ...prefixed('/racing/calendar', '/racing/racecards'),
  ...exact('/racing/columnists', '/columnists'),
  ...prefixed('/racing/courses', '/racing'),
  ...prefixed('/racing/draw_advantage', '/racing'),
  ...prefixed('/racing/goodwood', '/racing'),
  ...exact('/racing/live', '/racing'),
  ...prefixed('/racing/liveshows', '/racing'),
  ...prefixed('/racing/live-shows', '/racing/racecards'),
  ...prefixed('/racing/newbury', '/racing'),
  ...exact('/racing/notebook', '/racing'),
  ...prefixed('/racing/photos', '/racing'),
  ...exact('/racing/pointers', '/racing'),
  ...prefixed('/racing/racing_centre', '/racing/tips-centre'),
  ...exact('/racing/results/settlers.html', '/racing/results'),
  ...tooLittlePath('/racing/racecards', {preserveDate: true}),
  ...badDateFormat('/racing/racecards', {allowTomorrow: true}),
  ...exact('/racing/results/08-12-2016/aqueduct/result/755856/maiden-special-weight', '/nfl'), //Has to be in front of badDateFormat('/racing/results'...
  ...badDateFormat('/racing/results', {allowYesterday: true}),
  ...prefixed('/racing/racing_tipping_centre', '/racing/tips-centre'),
  ...prefixed('/racing/report', '/racing'),
  ...exact('/racing/results/search', '/racing/results'),
  ...prefixed('/search', '/racing/my-stable/search'),
  ...prefixed('/racing/profiles/search', '/racing/my-stable/search'),
  ...prefixed('/racing/stats', '/racing'),
  ...exact('/racing/steamers-drifters', '/racing/tips-centre'),
  ...exact('/racing/ten_to_follow', '/racing/tips-centre'),
  ...prefixed('/racing/tips-centre', '/racing/tips-centre'),
  ...exact('/racing/video', '/racing'),
  ...exact('/racting', '/racing'),
  ...exact('/fastresults', '/racing/fast-results'),
  '/racing/video(.*)': '/racing',
  ...exact('/rugbyleague', '/rugby-league'),
  ...legacyNews('/rugby-league'),
  ...prefixed('/rugbyleague', '/rugby-league'),
  ...prefixed('/rugbyunion', '/rugby-union'),
  ...legacyNews('/rugby-union'),
  ...legacyNews('/snooker'),
  ...prefixed('/soccer', '/football'),
  ...legacyNews('/tennis'),
  ...prefixed('/video', '/'),
  ...exact('/zone/golf/betting', '/golf'),
  ...exact('/football/missing-men', '/football'),
  ...exact('/football/national-league/table', '/football'),
  ...exact('/football/pools', '/football'),
  ...exact('/football/portuguese-liga/table', '/football'),
  ...exact('/football/scottish-league-cup', '/football'),
  ...exact('/football/top-scorers', '/football'),
  ...prefixed('/greyhounds/fast-results', '/greyhounds/fast-results'),
  ...prefixed('/greyhounds/live-shows', '/greyhounds/racecards'),
  ...exact('/greyhounds/non-runners', '/greyhounds/racecards'),
  ...prefixed('/greyhounds/profile/dog', '/greyhounds'),
  ...exact('/nfl/schedule', '/nfl'),
  ...exact('/nfl/standings', '/nfl'),
  ...exact('/photos', '/'),
  ...exact('/racing/fast-results-legacy', '/racing/fast-results'),
  ...exact('/racing/meeting/aqueduct/20-02-2017/fast-results', '/racing/fast-results'),
  ...exact('/racing/meeting/sedgefield/27-09-2016/fast-results', '/racing/fast-results'),
  ...prefixed('/racing/fast-results-legacy', '/racing/fast-results'),
  ...exact('/racing/point-to-point', '/racing'),
  ...prefixed('/snooker/draw', '/snooker'),
  ...exact('/tennis/atp-world-rankings', '/tennis'),
  ...exact('/tennis/fed-cup', '/tennis'),
  ...exact('/tennis/live', '/tennis'),
  ...prefixed('/tennis/live', '/tennis'),
  ...exact('/tennis/net-talk', '/tennis'),
  ...prefixed('/tennis/player-profile', '/tennis'),
  ...exact('/tennis/race-to-the-wta-championships', '/tennis'),
  ...exact('/tennis/results', '/tennis'),
  ...prefixed('/tennis/results', '/tennis'),
  ...prefixed('/tennis/video', '/tennis'),
  ...exact('/tennis/wta-world-rankings', '/tennis'),
  ...prefixed('/tv2/transfer-centre', '/'),
  ...prefixed('.*/news/article/[0-9]+/[0-9]+', '/') // Covers any old category which doesn't have its own legacyNews() entry
};



// WEBPACK FOOTER //
// ./utils/url-rewrite.js